import React from 'react';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
import { S } from './style';
import { Check } from '../../../atom/Icon';
export default function CheckCard({ onCardClick, isChecked, cardTitle, cardText }) {
    return (<S.CardBody onClick={onCardClick} isReadOnly={!onCardClick}>
      <S.CardBodyLeft isChecked={isChecked}>
        <S.CardBodyLeftTitle>{cardTitle}</S.CardBodyLeftTitle>
        <S.CardBodyLeftText>{cardText}</S.CardBodyLeftText>
      </S.CardBodyLeft>
      <S.CardBodyCheck isChecked={isChecked}>
        <Check color={SEMANTIC_COLORS.DEFAULT_ICON} size='30px'/>
      </S.CardBodyCheck>
    </S.CardBody>);
}
